import React from 'react';
import { Page } from '../Page';
import { Zap, Droplet, Award } from 'lucide-react';
export function SupplementWheyProtein() {
  return <Page pageNumber={10} variant="light" data-id="element-3730" data-mp="1k4ykttqasnut">
      <div className="flex h-full gap-10" data-id="element-3731" data-mp="1y2wvop5eu25k">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3732" data-mp="1y0si1fhplos3">
          <img src="https://cdn.magicpatterns.com/uploads/rz95qpTVrA12dEB643rF4b/pasted-image.png" alt="Thorne Whey Protein Isolate" className="w-full max-w-[280px] object-contain" data-id="element-3733" data-mp="1t2ip7bjgj09n" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3734" data-mp="2gslclecffi1x">
          <div className="mb-6 pt-4" data-id="element-3735" data-mp="2gvh7suww3smo">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3736" data-mp="2crt2kivqd94l">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3737" data-mp="2qpq0bilx7lku">
              Whey Protein Isolate
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3738" data-mp="2xl3xk92lm20e">
              Hit your protein goals when appetite is low
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3739" data-mp="32kgpv9c8o1ad" />
          </div>

          <div className="mb-8" data-id="element-3740" data-mp="37hys6gvr3i9e">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3741" data-mp="37hqfoq3jieyq">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3742" data-mp="3gk81j3fa95l7">
              When appetite is suppressed and portions are small, a high-quality
              protein shake is often the most practical way to hit 80-100g+
              daily targets. At 21g protein per scoop in just 100 calories, this
              is an extremely efficient protein-to-calorie ratio.
            </p>
          </div>

          <div className="mb-8" data-id="element-3743" data-mp="35l5yrq0nv1v">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3744" data-mp="36eik9bnperx">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3745" data-mp="8466ytd3eird">
              <li className="flex gap-2" data-id="element-3746" data-mp="247uinwdbrzil">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3747" data-mp="244oucjcit1nx" />
                <span data-id="element-3748" data-mp="207aisl1dahsr">
                  Preserves lean mass during weight loss with complete amino
                  acid profile
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3749" data-mp="2952yvrewxth7">
                <Droplet className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3750" data-mp="294b3ohp89xrg" />
                <span data-id="element-3751" data-mp="2nt79e83tayow">
                  Includes bromelain + papain digestive enzymes (helpful for
                  GLP-1 users with slowed digestion)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3752" data-mp="2wv6sr72auev0">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3753" data-mp="2rwlzxspdmxgl" />
                <span data-id="element-3754" data-mp="2ruj06gyf9pyo">
                  Whey isolate = easier digestion, lower lactose, NSF Certified
                  for Sport
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3755" data-mp="xjw4v7n9vi7m">
                <span className="text-tealslate shrink-0" data-id="element-3756" data-mp="395y2bm508a3z">•</span>
                <span data-id="element-3757" data-mp="396pzh1e92fwd">
                  Easy to consume when solid food feels difficult. Mix with
                  water, milk, or smoothies
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3758" data-mp="30bjpdq7y5bo1">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3759" data-mp="34epqykk46eo6">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3760" data-mp="2qfgcbpbk3smb">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3761" data-mp="2vfkv5lzxszfp">
                <strong data-id="element-3762" data-mp="2herxwti93q8w">1 scoop (30.2g)</strong> with at least 8oz liquid daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3763" data-mp="2hh4pzzhq3gzo">
                ~30 servings per 906g tub • 21g protein, 100 calories per
                serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3764" data-mp="flartu9rqxg9">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3765" data-mp="jnz308lyggge" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3766" data-mp="3m2krzz2c37rj">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}